import { IExportDeductionRepository, IExportDeductionRequest } from "@/core/repositories/export/export.deduction";
import { PrivateHttp } from "@/infrastructure/adapters/http";
import { ApiEndpoints } from "@/infrastructure/services/config";

export class ExportDeductionRepository implements IExportDeductionRepository {
  async exportDeduction(data: IExportDeductionRequest): Promise<{ signedUrl: string; success: boolean }> {
    const response = await new PrivateHttp().post<{ signedUrl: string; success: boolean }>(ApiEndpoints.EXPORT_EXCEL, data);
    return response;
  }
}
